<template>
	<div class="operation_box">
		<div class="operation_item">
			<md-button class="md-primary" @click="click">
				{{ $t("common.confirm")}}
			</md-button>
		</div>
	</div>
</template>

<script>
export default {
	methods: {
		click() {
			this.params.confirmAssignment(this.params.data);
		}
	},
};
</script>